module.exports = {
  RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST: 'RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST',
  RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS: 'RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS',
  RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_FAILURE: 'RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_FAILURE',
  ARRIVAL_UNLOCODE_CHECKED: 'ARRIVAL_UNLOCODE_CHECKED',
  ARRIVAL_POSTAL_OPERATOR_EXPANDED: 'ARRIVAL_POSTAL_OPERATOR_EXPANDED',
  SELECT_ALL_ARRIVAL_UNLOCODES: 'SELECT_ALL_ARRIVAL_UNLOCODES',
  DESELECT_ALL_ARRIVAL_UNLOCODES: 'DESELECT_ALL_ARRIVAL_UNLOCODES',
};
